import axios from '@/http/axios';

export default {
  markInvoicePaid: (oid, config: any = {}) => {
    return axios.put(
      `/service-payment-transactions/${oid}/mark-invoice-paid`,
      config
    );
  },
};
